import CustomButton from "../common/CustomBtn";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FacebookPostEmbed from "../FacebookPostEmbed";
import { Skeleton } from "@mui/material";
import { useFeedContext } from "../../helpers/feed/FeedContextProvider";

const LatestNews = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("home");
  const { homepageFeed } = useFeedContext();

  return (
    <section className="relative w-full h-full px-[5%] bg-[#Fafafa] ">
      <div className="py-20 maxContainer ">
        <span className="font-light text-tertiary">{t("newsSubHeading")}</span>
        <div className="flex flex-wrap items-center justify-between w-full gap-8 mt-2 mb-12">
          <h2 className="font-bold leading-tight text-[28px] ss:text-md md:text-lg max-w-[599px] ">
            {t("newsHeading")}
          </h2>
          <div className="hidden ss:flex">
            <CustomButton
              variant="outlined"
              color="primary"
              onClick={() => navigate("/naujausi")}
            >
              {t("newsBtnText")}
            </CustomButton>
          </div>
        </div>

        <div className="relative flex flex-wrap justify-center gap-12 sm:gap-8 ">
          {!homepageFeed.length &&
            Array.from(Array(4)).map((_, idx) => (
              <Skeleton
                key={idx}
                variant="rectangular"
                sx={{ width: "100%", height: "247px" }}
              />
            ))}

          {!!homepageFeed.length &&
            homepageFeed.map((post, idx) => (
              <FacebookPostEmbed
                key={idx}
                postUrl={post.permalink_url}
                // width={500}
              />
            ))}
        </div>

        <div className="flex justify-center w-full mt-12 ss:hidden">
          <CustomButton
            variant="outlined"
            color="primary"
            onClick={() => navigate("/naujausi")}
          >
            {t("newsBtnText")}
          </CustomButton>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
